// extracted by mini-css-extract-plugin
module.exports = {"EcomFormDrawerContainer":"styles_EcomFormDrawerContainer__ZGqWR","EcomFormDrawerForm":"styles_EcomFormDrawerForm__ld6Im"};